import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=6123e2f8&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=6123e2f8&prod&lang=css"
import style1 from "./shopDetails.vue?vue&type=style&index=1&id=6123e2f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6123e2f8",
  null
  
)

export default component.exports